import React from 'react';
import { GroupedUsernames } from '@components/GroupedUsernames/GroupedUsernames';
import { GroupedUsersAvatar } from '@components/GroupedUsernames/GroupedUsersAvatar';
import { ChannelFollowedMembersModal } from '@components/modals/Channels/ChannelFollowedMembersModal';
import { useAuth } from '@context/auth/base';
import { useModal } from '@context/modal';
import { ModalType } from '@context/modalType';
import { SPACE } from '@utils/constants';
import { useChannelFollowedMembers } from '../useChannelFollowedMembers';

const LIMIT = 5;

export const ChannelSocialProof = ({ channelId }: { channelId: string }) => {
  const { authUser } = useAuth();
  const { openModal } = useModal();

  const { memberCount, members, isLoading } = useChannelFollowedMembers({
    channelId,
    limit: LIMIT,
  });

  if ((!isLoading && memberCount === 0) || (!isLoading && !members.length) || !authUser) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center gap-4">
        <div className="flex flex-row-reverse">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={`social-proof-avatar-${index}`}
              className="-mr-3.5 h-6 w-6 animate-pulse rounded-full bg-neutral200 sm:-mr-3 "
            />
          ))}
        </div>
        <div className="h-3.5 w-48 animate-pulse rounded-md bg-neutral200 py-1 md:w-56" />
      </div>
    );
  }

  return (
    <div className="flex w-full items-center gap-1 md:gap-0">
      <div className="block md:hidden">
        <GroupedUsersAvatar users={members} variant="social-proof" />
      </div>
      <div className="inline-flex w-full flex-wrap items-center pr-2 md:flex md:flex-nowrap">
        <div className="hidden items-center md:flex">
          <GroupedUsersAvatar users={members} variant="social-proof" />
          {SPACE}
        </div>
        <div className="mb-[2px] flex items-baseline md:mb-0">
          <GroupedUsernames
            users={members}
            totalUsers={memberCount}
            othersOnClick={() => {
              openModal(ModalType.CHANNEL_MEMBERS, {
                body: <ChannelFollowedMembersModal channelId={channelId} />,
              });
            }}
            variant="social-proof"
          />
          <span className="hidden text-base-s md:block">who you're following joined.</span>
          <span className="block text-base-s md:hidden">joined.</span>
        </div>
      </div>
    </div>
  );
};
